import { Outlet, NavLink, useNavigate, Navigate, useLocation } from "react-router-dom";
import { useGestAuth } from "./GestAuthContext";
import { motion } from "framer-motion";
import GestAiAssistant from "./GestAiAssistant";

function Mark({ size = 22 }) {
  const symbolSide = 70, offset = 15, gap = 6.3, tile = 31.85, outerR = 7, strokeW = 6, innerR = 4;
  const tiles = [];
  for (let r = 0; r < 2; r++) for (let c = 0; c < 2; c++) tiles.push({ x: offset + c * (tile + gap), y: offset + r * (tile + gap) });
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} aria-hidden="true">
      <g fill="currentColor">{tiles.map((t, i) => (
        <g key={i}>
          <rect x={t.x} y={t.y} width={tile} height={tile} rx={outerR} />
          <rect x={t.x + strokeW} y={t.y + strokeW} width={tile - 2 * strokeW} height={tile - 2 * strokeW} rx={innerR} fill="#0a1420" />
        </g>
      ))}</g>
    </svg>
  );
}

function IconHome() { return (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12L12 3l9 9"/><path d="M5 10v10h14V10"/></svg>); }
function IconBuild() { return (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="10" width="18" height="11" rx="1"/><rect x="7" y="3" width="10" height="7"/><line x1="7" y1="14" x2="9" y2="14"/><line x1="15" y1="14" x2="17" y2="14"/></svg>); }
function IconProd() { return (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 3v6h6v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/><polyline points="14 3 20 9"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/></svg>); }
function IconPosa() { return (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="1"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="12" y1="4" x2="12" y2="20"/></svg>); }
function IconUsers() { return (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>); }
function IconDoc() { return (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M8 13l2 2 4-4"/></svg>); }
function IconSettings() { return (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.01a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.01a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>); }
function IconOut() { return (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>); }

const roleLabel = { admin: "Amministratore", ufficio: "Ufficio", produzione: "Produzione", posa: "Posa" };

export default function GestLayout() {
  const { user, logout } = useGestAuth();
  const nav = useNavigate();
  const location = useLocation();

  if (user === null) {
    return <main className="min-h-screen bg-[#0a1420] text-white flex items-center justify-center text-[13px] text-white/40">Caricamento…</main>;
  }
  if (!user) return <Navigate to="/gestione/login" replace />;

  const isAdmin = user.role === "admin";
  const isUfficio = user.role === "ufficio";
  const canDashboard = user.role === "admin" || user.role === "ufficio";
  const canProd = ["admin", "ufficio", "produzione"].includes(user.role);
  const canPosa = ["admin", "ufficio", "posa"].includes(user.role);

  const items = [
    { to: "/gestione", end: true, label: "Dashboard", icon: IconHome, show: canDashboard },
    { to: "/gestione/cantieri", label: "Cantieri", icon: IconBuild, show: true },
    { to: "/gestione/produzione", label: "Produzione", icon: IconProd, show: canProd },
    { to: "/gestione/posa", label: "Posa", icon: IconPosa, show: canPosa },
    { to: "/gestione/documenti", label: "Documenti IA", icon: IconDoc, show: isAdmin || isUfficio },
    { to: "/gestione/utenti", label: "Utenti", icon: IconUsers, show: isAdmin },
    { to: "/gestione/impostazioni", label: "Impostazioni", icon: IconSettings, show: isAdmin },
  ].filter((i) => i.show);

  const handleLogout = async () => { await logout(); nav("/gestione/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-[#f5f7fb] flex" data-testid="gest-layout">
      {/* Desktop sidebar */}
      <aside className="hidden md:flex md:w-[240px] flex-col bg-[#0a1420] text-white shrink-0">
        <div className="px-6 pt-7 pb-8 flex items-center gap-2.5">
          <span className="text-[#a7c8e9]"><Mark size={22} /></span>
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-white/50">HGW</div>
            <div className="text-[13px] font-semibold leading-none mt-1">Site Management</div>
          </div>
        </div>
        <nav className="px-3 flex-1 space-y-0.5">
          {items.map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              end={i.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-[13.5px] transition-colors ${
                  isActive ? "bg-white/10 text-white" : "text-white/60 hover:text-white hover:bg-white/[0.06]"
                }`
              }
              data-testid={`gest-nav-${i.label.toLowerCase()}`}
            >
              <i.icon /> {i.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/5">
          <div className="text-[11px] text-white/45 uppercase tracking-wider">{roleLabel[user.role] || user.role}</div>
          <div className="text-[13px] font-medium truncate mt-0.5">{user.name}</div>
          <div className="text-[11px] text-white/40 truncate">{user.email}</div>
          <button
            type="button"
            onClick={handleLogout}
            data-testid="gest-logout"
            className="mt-4 w-full flex items-center gap-2 justify-center px-3 py-2 rounded-lg bg-white/5 text-white/70 hover:bg-white/10 hover:text-white text-[12px] transition-colors"
          >
            <IconOut /> Esci
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="md:hidden fixed top-0 inset-x-0 z-40 bg-[#0a1420] text-white px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2 text-[#a7c8e9]"><Mark size={18} /><span className="text-[13px] font-semibold text-white">HGW Site Management</span></div>
        <button type="button" onClick={handleLogout} className="text-[12px] text-white/60 hover:text-white" data-testid="gest-logout-mobile">Esci</button>
      </div>

      <main className="flex-1 min-w-0 pt-14 md:pt-0 pb-24 md:pb-0">
        <motion.div key={location.pathname} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.25 }}>
          <Outlet />
        </motion.div>
      </main>

      {/* Mobile bottom nav */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-black/5 pb-[env(safe-area-inset-bottom)]">
        <div className="overflow-x-auto no-scrollbar">
          <div className="flex items-stretch min-w-max px-2 py-1.5">
            {items.map((i) => (
              <NavLink
                key={i.to}
                to={i.to}
                end={i.end}
                className={({ isActive }) =>
                  `min-w-[68px] flex flex-col items-center gap-0.5 py-1.5 px-2 rounded-lg text-[10.5px] whitespace-nowrap ${
                    isActive ? "text-[#0a1420] font-medium" : "text-[#6e6e73]"
                  }`
                }
                data-testid={`gest-nav-mobile-${i.label.toLowerCase()}`}
              >
                <i.icon />
                <span className="text-[10px] mt-0.5">{i.label}</span>
              </NavLink>
            ))}
          </div>
        </div>
      </nav>

      {/* Floating AI assistant (admin + ufficio only, self-gated inside) */}
      <GestAiAssistant />
    </div>
  );
}
